import type { Optional } from '@gov-nx/core/types';
import type { FormInputProps } from './FormInput';
import { FormInput } from './FormInput';

interface FormNumberInputProps extends FormInputProps {
	options?: {
		noSpin: boolean;
	};
}

export const FormNumberInput = (props: FormNumberInputProps) => (
	<FormInput<number>
		{...props}
		field={{
			size: 'm',
			...props.field,
			type: 'number',
			noSpin: props.options?.noSpin ?? false,
		}}
		toValue={(event): Optional<number> =>
			event ? parseInt(event.currentTarget.value, 10) : undefined
		}
		fromValue={(int) => {
			if (typeof int === 'number') {
				return `${int}`;
			}
			return int;
		}}
	/>
);
